import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { useConnectivity } from '../../hooks/useConnectivity';

// =====================================================================
// iSentinel360 v0.4.1 — AdminFooter
//
// Extracted from src/pages/AdminDashboard.tsx. Lighter than the
// guard footer — just the store name, the user, and the version.
// No switch-store button (admin doesn't have one), no alert status
// indicator.
//
// Hides itself when the user is offline for the same reason as
// GuardFooter: the i18n keys won't resolve cleanly without network.
// =====================================================================

declare const __APP_VERSION__: string;

interface AdminFooterProps {
  activeStoreName: string | null;
}

export default function AdminFooter({ activeStoreName }: AdminFooterProps) {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { isOnline } = useConnectivity();

  if (!isOnline) return null;

  return (
    <div className="flex-shrink-0">
      <footer className="text-center text-xs text-muted-foreground py-3 border-t">
        {activeStoreName && (
          <span className="mr-2">{activeStoreName}</span>
        )}
        <div className="text-xs text-muted-foreground/70">
          {t('guard.user')}: {user?.name || 'Unknown'}
        </div>
        <span className="opacity-60 inline-block -ml-2">v.{__APP_VERSION__}</span>
      </footer>
    </div>
  );
}
